// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { useBooleanToggle } from 'hooks'
import React, { useEffect } from 'react'
import { string } from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { AFS_PARAMETERS } from 'redux/modules/interferenceAnalysis/constants'
import triggerProjectAnalysisToRun from 'redux/modules/interferenceAnalysis/thunks/triggerProjectAnalysisToRun'

// NOTE - this component is used as a notification when a protection project is created but
// the analysis failed to kick off. This will mount before we arrive at the Run Analysis page
// but will look for the AFS_PARAMETERS to be initialized before triggering Run Analysis to be triggered
// and thus showing the Analysis Errors for the user.

const ProtectionProjectAnalysisFailedToInitialize = props => {
  const {
    rcnNumber,
    uid,
  } = props

  const dispatch = useDispatch()

  const [hasTriggered, toggleHasTriggered] = useBooleanToggle(false)

  const formHasInitialized = useSelector(state => !!state.form[AFS_PARAMETERS])

  useEffect(() => {
    if (
      !hasTriggered &&
      formHasInitialized
    ) {
      dispatch(triggerProjectAnalysisToRun())
      toggleHasTriggered()
    }
  }, [hasTriggered, formHasInitialized])

  return (
    <div>
      {`Protection Project for RCN ${rcnNumber} was created. However, analysis failed to initialize. Please review the errors on screen.`}
    </div>
  )
}

ProtectionProjectAnalysisFailedToInitialize.propTypes = {
  rcnNumber: string.isRequired,
  uid: string.isRequired,
}
export default ProtectionProjectAnalysisFailedToInitialize
